import { defineStore } from 'pinia'
import { ref } from 'vue'
// import { syncDiving } from '~/services/syncData'
import { registerSW } from 'virtual:pwa-register'

export const useStoreApp = defineStore('app', () => {
  const appState = ref({
    isOnline: navigator.onLine,
    pwaOfflineReady: false,
    appOfflineReady: false,
    offlineReady: false,
    dataToSync: {}
  })

  registerSW({
    onNeedRefresh() {
      console.log('App updated')
    },
    onOfflineReady() {
      console.log('[app store] All assets ready')
      appState.value.pwaOfflineReady = true
    },
  })

  async function updateOnlineStatus() {
    console.log('[app store] App is going ' + (navigator.onLine ? 'online' : 'offline'))
    appState.value.isOnline = navigator.onLine
  }

  return {
    appState,
    updateOnlineStatus,
  }
})
